import * as React from 'react';
import './style.scss';
interface LoadinProps {
    icon: JSX.Element;
    text?: string;
}
const Loading: React.FC<LoadinProps> = (props) => {
    const { icon, text } = props;
    return (
        <div className="loading">
            <div className="iconBlock">{icon}</div>
            <div className="notes">{text}</div>
        </div>
    );
};

export default Loading;
